module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("PSC " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))]), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_c('p', [_vm._v("\n        As condições gerais para a prestação dos serviços do PSC " + _vm._s(_vm.pscs[_vm.pscselecionado].nome) + " estão\n        descritas na DPPSC e PS, disponíveis no link abaixo.\n      ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Prestador de Serviço de Confiança " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Situação atual:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.pscs[_vm.pscselecionado].situacao))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Capacidade de armazenamento de chaves privadas")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.pscs[_vm.pscselecionado].capacidade))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Serviços implementados")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.pscs[_vm.pscselecionado].servicos))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.pscs[_vm.pscselecionado].documentos.dppsc
    }
  }, [_vm._v("DPPSC " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Declaração de Práticas do Prestador de Serviço de Confiança " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.pscs[_vm.pscselecionado].documentos.ps
    }
  }, [_vm._v("PS " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Política de Segurança do Prestador de Serviço de Confiança " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))])])]), _vm._v(" "), (_vm.pscs[_vm.pscselecionado].dou) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("DOU - Diário Oficial da União")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.pscs[_vm.pscselecionado].dou.link
    }
  }, [_vm._v("Publicação do credenciamento do PSC " + _vm._s(_vm.pscs[_vm.pscselecionado].nome))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pscs[_vm.pscselecionado].dou.descricao))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Condições gerais")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Condições gerais mediante as quais são prestados os serviços de armazenamento de chaves privadas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Armazenamento de chaves")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Chaves armazenadas em dispositivos de segurança em hardware ( HSMs ) e hospedados em Salas Cofres credenciadas pelo órgão regulador.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuidade do serviço")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pretende continuar a prestar o serviço ou se está mediante a qualquer fiscalização dos serviços?  Prestação de serviço contínua")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-582f7de6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RepositorioPSC.vue
// module id = 101
// module chunks = 0